var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:('background-color: ' + _vm.backgroundColour),attrs:{"id":"app"}},[_c('b-container',{staticClass:"p-0",attrs:{"fluid":""}},[_c('router-view')],1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e2781e4","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./src/components/app/app.html
// module id = null
// module chunks = 